import { render, staticRenderFns } from "./DealPage.vue?vue&type=template&id=2c002a46&"
import script from "./DealPage.vue?vue&type=script&lang=js&"
export * from "./DealPage.vue?vue&type=script&lang=js&"
import style0 from "./DealPage.vue?vue&type=style&index=0&id=2c002a46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports